/* eslint-disable no-unused-vars -- TypeScript interface parameter names document the public notification API. */
import { createContext, useContext } from 'react';

export type NotificationVariant = 'success' | 'warning' | 'error' | 'info';

export interface NotificationInput {
  title: string;
  message?: string;
  variant?: NotificationVariant;
  duration?: number;
}

export interface NotificationApi {
  notify(notification: NotificationInput): string;
  success(title: string, message?: string): string;
  warning(title: string, message?: string): string;
  error(title: string, message?: string): string;
  info(title: string, message?: string): string;
  dismiss(id: string): void;
}

export const NotificationContext = createContext<NotificationApi | null>(null);

export function useNotifications() {
  const context = useContext(NotificationContext);
  if (!context) throw new Error('useNotifications must be used within NotificationProvider');
  return context;
}
